import type { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { ErrorBoundary } from '../shared/ui/ErrorBoundary';
import './styles/route-error.css';

/** Loi tai chunk JS (vua trien khai ban moi, ten tep cu khong con) — tai lai la het. */
const isChunkError = (e: Error) =>
  /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module/i.test(e.message);

/** Loi ve giao dien cua MOT trang: bao gon + nut tai lai, chuyen sang duong dan khac thi tu het. */
export function RouteErrorBoundary({ children }: { children: ReactNode }) {
  const { pathname } = useLocation();
  return (
    <ErrorBoundary
      resetKey={pathname}
      fallback={(error, reset) => (
        <div className="route-error" role="alert">
          <div className="route-error-card">
            <h1>{isChunkError(error) ? 'Đã có phiên bản mới' : 'Trang gặp lỗi khi hiển thị'}</h1>
            <p>
              {isChunkError(error)
                ? 'Hệ thống vừa được cập nhật. Tải lại trang để dùng phiên bản mới.'
                : 'Dữ liệu vẫn an toàn. Thử tải lại trang; nếu vẫn lỗi, gửi nội dung dưới đây cho quản trị.'}
            </p>
            <pre>{error.message}</pre>
            <div className="route-error-actions">
              <button type="button" onClick={() => window.location.reload()}>
                Tải lại trang
              </button>
              <button type="button" className="secondary" onClick={reset}>
                Thử hiển thị lại
              </button>
              <a href="/apps">Về trang ứng dụng</a>
            </div>
          </div>
        </div>
      )}
    >
      {children}
    </ErrorBoundary>
  );
}
